/* eslint-disable extra-rules/no-commented-out-code */
import useInjectReducerAndSaga from '@tcp/core/src/utils/useInjectReducerAndSaga';

export default async () => {
  const [ApplyCardReducer, ApplyNowModalPLCCReducer, ApplyCreditCardSaga] = await Promise.all([
    import(/* webpackChunkName: "apply-card-page" */ './ApplyCard.reducer'),
    import(
      /* webpackChunkName: "apply-card-page" */ '@tcp/core/src/components/common/molecules/ApplyNowPLCCModal/container/ApplyNowModal.reducer'
    ),
    import(/* webpackChunkName: "apply-card-page" */ './ApplyCard.saga'),
  ]);
  useInjectReducerAndSaga(
    { key: 'ApplyCardPage', reducer: ApplyCardReducer.default },
    { key: 'ApplyCardPage', saga: ApplyCreditCardSaga.default }
  );
  useInjectReducerAndSaga(
    { key: 'ApplyNowModal', reducer: ApplyNowModalPLCCReducer.default },
    { key: 'ApplyCardPageSaga', saga: ApplyCreditCardSaga.SubmitInstantCardApplication }
  );
  return null;
};
